import { render } from "./CGVU.vue?vue&type=template&id=32abd0b0"
import script from "./CGVU.vue?vue&type=script&lang=js"
export * from "./CGVU.vue?vue&type=script&lang=js"

import "./CGVU.vue?vue&type=style&index=0&id=32abd0b0&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__